import { useState, useEffect, useContext } from "react";
import { Link } from "react-router-dom";
import { useForm } from "react-hook-form";
import { DataContext } from 'providers/data';
import { useNavigate } from "react-router-dom";

import * as Regex from 'utils/validations';

import Collapse from '@mui/material/Collapse';
import Input from 'components/views/form/Input';
import { Typography, Box, Button } from '@mui/material';
import ContentForgot from 'components/views/ContentForgot';
import { ButtonOutlined, ButtonRectangle } from 'components/views/form/Button';

import BackgroundForgotLogin from 'assets/images/background-forgot-login.png';
import { ReactComponent as IcIturinOk } from 'assets/icons/ic-iturin-ok.svg';
import { ReactComponent as IcIturinCoverage } from 'assets/icons/ic-iturin-coverage.svg';
import { ReactComponent as IcCopyAndPasteTicket } from 'assets/icons/ic-copy-and-paste-ticket.svg';

const ForgotLogin = () => {
    const navigate = useNavigate();
    const { register, watch } = useForm();
    const { dataValidateDocument, handlePostValidateDocument, handlePostObtainUserLogin, handleClearAuthentication } = useContext(DataContext);

    const [stepRecoveryLogin, setStepRecoveryLogin] = useState(0);
    const [enableBtnIdentity, setEnableBtnIdentity] = useState(false);

    const identity: string = watch('identity');
    const cep = watch('cep');
    const boardOrChassis = watch('boardOrChassis');

    const handlePostValidateDocumentState = () => {
        handlePostValidateDocument({ document: identity });
    }

    const handlePostObtainUserLoginState = () => {
        handlePostObtainUserLogin({
            chassi: boardOrChassis?.length > 7 ? boardOrChassis : '',
            document: identity,
            plate: boardOrChassis?.length <= 7 ? boardOrChassis : '',
            zipCode: cep
        }, true);
    }

    useEffect(() => {
        if (dataValidateDocument?.userFound) {
            if (Regex.matchesIdentity(identity) && cep?.match(Regex.cep) && boardOrChassis?.match(Regex.chassisOrBoard)) {
                setEnableBtnIdentity(false);
            } else {
                setEnableBtnIdentity(true);
            }
        } else {
            if (Regex.matchesIdentity(identity)) {
                setEnableBtnIdentity(false);
            } else {
                setEnableBtnIdentity(true);
            }
        }
    }, [identity, cep, boardOrChassis, dataValidateDocument]);

    useEffect(() => {
        if (dataValidateDocument) {
            if (dataValidateDocument.userFound && dataValidateDocument.UsuarioEncontrado && dataValidateDocument.UsuarioCadastrado) {
                setStepRecoveryLogin(2);

                if (dataValidateDocument?.obtainUserLogin) {
                    setStepRecoveryLogin(3);
                } else if (dataValidateDocument?.obtainUserLogin === false) {
                    setStepRecoveryLogin(1);
                }
            } else {
                setStepRecoveryLogin(1);
            }
        }
    }, [dataValidateDocument]);

    return (
        <ContentForgot background={BackgroundForgotLogin} titleNav="Esqueci meu login">
            <Box sx={{
                height: '100%',
                display: 'flex',
                marginTop: '-3rem',
                flexDirection: 'column',
                justifyContent: 'center'
            }}>
                {stepRecoveryLogin !== 1 &&
                    <Box sx={{
                        width: {
                            xs: '100%',
                            md: '25rem'
                        },
                        display: 'flex',
                        margin: '0 auto',
                        textAlign: 'center',
                        borderRadius: '10px',
                        alignItems: 'center',
                        flexDirection: 'column',
                        padding: '2.375rem 1.6875rem',
                        border: {
                            xs: 'none',
                            md: '1.5px solid rgba(12, 28, 51, 0.5)'
                        },
                        'button': {
                            width: '100%',
                            marginTop: '.6875rem'
                        }
                    }}>
                        <Typography fontSize='1.5625rem' fontWeight={700} sx={{ display: { xs: 'none', md: 'flex' } }}>
                            Esqueci meu login
                        </Typography>

                        <Collapse in={stepRecoveryLogin !== 3} sx={{ width: '100%' }}>
                            <>
                                <Typography fontSize='.875rem' fontWeight={400} sx={{
                                    padding: {
                                        xs: '0 0 3.25rem',
                                        md: '1rem 0 1.875rem'
                                    }
                                }}>
                                    Para informar seu login, preencha o campo abaixo.
                                </Typography>

                                <Input
                                    name='identity'
                                    label='Insira seu CPF ou CNPJ'
                                    placeholder='000.000.000-00'
                                    type='tel'
                                    mask
                                    identity
                                    textError="Insira um número válido"
                                    register={{ ...register("identity", { pattern: Regex.identity }) }} />

                                <Collapse in={stepRecoveryLogin === 2}>
                                    <Box>
                                        <Box sx={{ maxWidth: '10.93rem' }}>
                                            <Input
                                                name='cep'
                                                label='CEP do cadastro'
                                                placeholder='00000-000'
                                                maskHolder='99999-999'
                                                mask
                                                type='tel'
                                                register={{ ...register("cep", { pattern: Regex.cep }) }} />
                                        </Box>
                                        <Input
                                            name='boardOrChassis'
                                            label='Recupere seu login usando a Placa do veículo ou Chassi:'
                                            placeholder='0000000000000000000'
                                            type='text'
                                            mask
                                            identity
                                            typeIdentity='plaque'
                                            register={{ ...register("boardOrChassis", { pattern: Regex.chassisOrBoard }) }}
                                            uppercase
                                        />
                                    </Box>
                                </Collapse>
                            </>
                        </Collapse>

                        <Collapse in={stepRecoveryLogin === 3} sx={{ width: '100%' }}>
                            <Box sx={{ display: { xs: 'block', md: 'none' } }}>
                                <IcIturinOk />
                            </Box>
                            <Typography fontSize='.875rem' fontWeight={400} sx={{
                                padding: {
                                    xs: '0 0 .625rem',
                                    md: '2.56rem 0 .625rem'
                                }
                            }}>
                                SEU LOGIN DE ACESSO É:
                            </Typography>
                            <Box sx={{ display: 'flex', gap: '.5rem', 'button': { margin: '0' } }}>
                                <Typography
                                    fontSize='1.14rem'
                                    fontWeight={700}
                                    padding='.93rem .6rem 0rem'
                                    marginBottom='1.5rem'
                                    sx={{
                                        width: '100%',
                                        height: '2.8125rem',
                                        borderRadius: '5px',
                                        border: '1.5px solid #8D9BB5'
                                    }}>
                                    {dataValidateDocument?.userLogin}
                                </Typography>
                                <Button sx={{
                                    border: '1.5px solid #8D9BB5',
                                    maxWidth: '40px',
                                    height: '2.8125rem',
                                    minWidth: '0',
                                    margin: '0',
                                    padding: '0',
                                    borderRadius: '5px',
                                }}
                                    onClick={() => navigator.clipboard.writeText(dataValidateDocument?.userLogin || '')}>
                                    <IcCopyAndPasteTicket />
                                </Button>
                            </Box>
                        </Collapse>

                        <ButtonRectangle
                            name={stepRecoveryLogin === 0 ? "CONTINUAR" : stepRecoveryLogin === 2 ? "RECUPERAR" : 'ACESSAR'}
                            disabled={enableBtnIdentity}
                            onClick={() =>
                                stepRecoveryLogin === 0 ? handlePostValidateDocumentState() :
                                    stepRecoveryLogin === 2 ? handlePostObtainUserLoginState() :
                                        (navigate('/', { state: { login: dataValidateDocument?.userLogin } }),
                                            handleClearAuthentication())
                            }
                        />

                        <Collapse in={stepRecoveryLogin === 0}>
                            <Link
                                to='/esqueci-senha'
                                style={{
                                    display: 'flex',
                                    width: 'fit-content',
                                    margin: '2.75rem 0 .5rem'
                                }}>
                                <Typography sx={{ fontSize: '.875rem', textDecoration: 'underline', fontWeight: 600 }}>
                                    esqueci minha senha
                                </Typography>
                            </Link>
                        </Collapse>
                    </Box>
                }

                {stepRecoveryLogin === 1 &&
                    <Box sx={{ display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center' }}>
                        <IcIturinCoverage />
                        <Box sx={{
                            border: '1.5px solid rgba(10, 168, 227, 0.45)',
                            borderRadius: '10px',
                            maxWidth: '21.875rem',
                            padding: '1.5625rem 1.25rem 1.875rem',
                            marginTop: '-30px',
                            backgroundColor: 'white',
                            'button': {
                                width: '100%',
                                height: '2.5rem',
                                marginTop: '.875rem'
                            }
                        }}>
                            <Typography fontSize='1.5625rem' textAlign='center' fontWeight={700}>
                                Login não localizado.
                            </Typography>
                            <Typography fontSize='1rem' textAlign='center' marginTop='1.875rem'>
                                Ainda não é cadastrado?
                            </Typography>
                            <ButtonRectangle name="1º ACESSO" onClick={() => { navigate('/primeiro-acesso'); handleClearAuthentication(); }} />
                            <ButtonOutlined
                                name="TENTAR NOVAMENTE"
                                onClick={() => setStepRecoveryLogin(dataValidateDocument?.userFound ? 2 : 0)} />
                        </Box>
                    </Box>
                }

                <Collapse in={stepRecoveryLogin === 0} sx={{ display: { xs: 'none', md: 'block' } }}>
                    <Box width='100%' textAlign='center'>
                        <Typography variant='h6' fontWeight={500} sx={{
                            margin: {
                                md: '6.125rem 0 .5rem',
                                xs: '2rem 0'
                            }
                        }}>
                            Ainda não é cadastrado?
                        </Typography>

                        <Button variant="outlined" type='button' sx={{
                            width: '100%',
                            maxWidth: '20.31rem',
                            height: '2.8175rem',
                            borderRadius: '5px',
                            border: '1.5px solid #0C1C33',
                            fontSize: '1rem',
                            fontWeight: 700
                        }}
                            onClick={() => navigate('/primeiro-acesso')}
                        >
                            1º ACESSO
                        </Button>
                    </Box>
                </Collapse>

                <Collapse in={stepRecoveryLogin === 0} sx={{ display: { xs: 'block', md: 'none' } }}>
                    <Box sx={{ paddingTop: '3.25rem' }}>
                        <Box sx={{
                            width: '12.5rem',
                            height: '.07rem',
                            background: 'rgba(28, 56, 107, 0.40)',
                            margin: '0 auto 3.375rem',
                        }} />
                        <Link to='/primeiro-acesso' onClick={() => handleClearAuthentication()}>
                            <Typography fontWeight={600} sx={{
                                fontSize: '.875rem',
                                textAlign: 'center',
                                color: '#ABAEAE',
                                'strong': {
                                    color: 'primary.main',
                                    textDecoration: 'underline'
                                }
                            }}>
                                Ainda não é cadastrado? <strong>1º Acesso</strong>
                            </Typography>
                        </Link>
                    </Box>
                </Collapse>
            </Box>
        </ContentForgot>
    );
}

export default ForgotLogin;